<template>
  <b-modal
    ref="modal"
    :title="$t('Cancelar importação')"
    centered
    hide-footer
  >
    <div>
      <p class="mb-3">
        {{ $t("Tem certeza que deseja cancelar esta importação?") }}
      </p>

      <div v-if="importacao" class="alert alert-warning py-2">
        <strong>{{ $t("Arquivo") }}:</strong>
        {{ importacao.original_filename || "-" }}
      </div>

      <b-form-checkbox v-model="deleteFile">
        {{ $t("Apagar arquivo de importação?") }}
      </b-form-checkbox>

      <div class="d-flex justify-content-end mt-4">
        <button
          type="button"
          class="btn btn-secondary mr-2"
          @click="fecharModal"
        >
          {{ $t("Voltar") }}
        </button>

        <button
          type="button"
          class="btn btn-warning"
          @click="confirmar"
        >
          <i class="fas fa-ban"></i>
          {{ $t("Confirmar cancelamento") }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "CancelarImportacaoModal",

  data() {
    return {
      importacao: null,
      deleteFile: false,
    };
  },

  methods: {
    abrirModal(importacao) {
      this.importacao = importacao;
      this.deleteFile = false;
      this.$refs.modal.show();
    },

    fecharModal() {
      this.$refs.modal.hide();
    },

    confirmar() {
      if (!this.importacao || !this.importacao.id) {
        return;
      }

      this.$emit("confirm", {
        importacao: this.importacao,
        delete_file: this.deleteFile,
      });

      this.fecharModal();
    },
  },
};
</script>